__turbopack_context__.v({
  "errorWrapper": "styles-module-scss-module__KudpNG__errorWrapper",
  "subtitle": "styles-module-scss-module__KudpNG__subtitle",
  "title": "styles-module-scss-module__KudpNG__title",
});
